// extracted by mini-css-extract-plugin
export default {"loading-container":"styles-scoped__loading-container--X9Cw9","loadingContainer":"styles-scoped__loading-container--X9Cw9"};